var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.5,
    height: 24.5,
    viewBox: "0 0 24.5 24.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8114",
    "data-name": "Grupo 8114",
    transform: "translate(401.937 -63.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5609",
    "data-name": "Caminho 5609",
    d: "M-391.177,78.685a1.251,1.251,0,0,0,0,1.767,1.244,1.244,0,0,0,.884.366,1.244,1.244,0,0,0,.884-.366l4.116-4.116a1.253,1.253,0,0,0,.27-.407,1.258,1.258,0,0,0,0-.955,1.26,1.26,0,0,0-.271-.408l-4.116-4.115a1.251,1.251,0,0,0-1.768,0,1.244,1.244,0,0,0-.366.884,1.244,1.244,0,0,0,.366.884l1.983,1.982h-11.493a1.252,1.252,0,0,0-1.25,1.25,1.251,1.251,0,0,0,1.25,1.25h11.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5610",
    "data-name": "Caminho 5610",
    d: "M-380.187,63.2h-15a3.035,3.035,0,0,0-2.75,3.25v4.267a1.085,1.085,0,0,0,1.084,1.083,1.084,1.084,0,0,0,1.083-1.083V66.451a.693.693,0,0,1,.583-.75h15a.684.684,0,0,1,.584.75v18a.684.684,0,0,1-.584.75h-15a.684.684,0,0,1-.583-.75V80.384a1.083,1.083,0,0,0-1.083-1.083,1.084,1.084,0,0,0-1.084,1.083v4.067a3.035,3.035,0,0,0,2.75,3.25h15a3.035,3.035,0,0,0,2.75-3.25v-18A3.035,3.035,0,0,0-380.187,63.2Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.192c0621.svg";
export { ForwardRef as ReactComponent };